import { Box, Stack, styled, ThemeContext } from '@migros/msrc-ui-kit';
import React, { useContext } from 'react';
import { ListStyleType } from '../../helpers';
import { Card } from '../../elements/card/Card';
import { ArticleMiniContainer, ArticleMiniImage } from '../../elements/tiles/partials';
import { SkeletonBox } from './SkeletonBox';
export const ArticleMiniSkeleton = ({
  mode = ListStyleType.default
}) => {
  const theme = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(Card, {
    mode: mode,
    theme: theme,
    "data-testid": "msrc-articles--article-mini-skeleton"
  }, /*#__PURE__*/React.createElement(ArticleMiniContainer, {
    display: ['flex'],
    alignItems: ['center']
  }, /*#__PURE__*/React.createElement(Stack, {
    orientation: "horizontal",
    position: ['relative'],
    alignItems: ['center'],
    size: ['xsmall', 'medium'],
    flex: "1 1 auto"
  }, /*#__PURE__*/React.createElement(ArticleMiniImage, null, /*#__PURE__*/React.createElement(SkeletonBox, null)), /*#__PURE__*/React.createElement(StyledStack, {
    size: ['small']
  }, /*#__PURE__*/React.createElement(Box, {
    style: {
      height: '16px',
      marginRight: '10%'
    },
    position: ['relative']
  }, /*#__PURE__*/React.createElement(SkeletonBox, null)), /*#__PURE__*/React.createElement(Box, {
    style: {
      height: '16px',
      marginRight: '20%'
    },
    position: ['relative']
  }, /*#__PURE__*/React.createElement(SkeletonBox, null)), /*#__PURE__*/React.createElement(Box, {
    style: {
      height: '16px',
      marginRight: '40%'
    },
    position: ['relative']
  }, /*#__PURE__*/React.createElement(SkeletonBox, null))))));
};
const StyledStack = styled(Stack)`
  width: 100%;
`;